<template>
  <div class="news">
    <div id="title">
        <h1>最新消息</h1>
    </div> 
    <div class="container">
        <button :class="'btn' + this.active1" @click="sentfilter('')" :value="''" style="font-family: 'Noto Sans TC', sans-serif;">全部消息</button>
        <button :class="'btn' + this.active2" @click="sentfilter('企業活動')" :value="'企業活動'" style="border-left:0;border-right:0;font-family: 'Noto Sans TC', sans-serif;">企業活動</button>
        <button :class="'btn' + this.active3" @click="sentfilter('金石盃賽')" :value="'金石盃賽'" style="font-family: 'Noto Sans TC', sans-serif;">金石盃賽</button>

      <div class="newslist">
        <span v-for="(news, index) in filternews" :key="news.id" v-show=" ((pagenumber-1)*5 <= index)&& (index < (pagenumber)*5)">
          <span id="newsdate">{{news.date}}</span><span id="newstitle">{{news.title}}</span>
          <div id="newscontent"><a :href="news.href">{{news.content}}</a></div>
          <hr id="newshr">
        </span>
        <span id="pageoffset"><hr id="pagehrleft">
        <span v-for="i in pageoffsetnumber" :key="i" :value="i" @click="pagesetting(i)"
             :class="{ pagepactive : pagenumber == i , pagep :  i }">{{i}}</span>
        <hr id="pagehrright"></span>
      </div>
      <div class="newsvideo">
        <div class="video-container">
          <iframe :src="this.vedioselect" width="272" height="154" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
          <button v-for="vedio in vediosrc" :key="vedio.id" @click="showthisvedio(vedio)"
           :class="{yellowoval: vedio.id === ovalnumber, greyoval: vedio.id !== ovalnumber}"></button>
      </div>
    </div>

  </div>
  
</template>
 
<script>
export default {
  data(){
    return {     
      filtername:'', active1:' active',active2:'',active3:'', //button
      newslist:[],filterchoice:"",  //最新消息
      pagenumber:1, //頁數
      limiter: 0, 
      vediosrc: [
        {id:1,source:"https://www.youtube.com/embed/wKPiBhxgCEA"},
        {id:2,source:"https://www.youtube.com/embed/kRlV9BjvjS0?start=10"},
        {id:3,source:"https://www.youtube.com/embed/NnshncgILEs?start=3"},
        {id:4,source:"https://www.youtube.com/embed/DIMj3V1hzjY?start=3"},
        {id:5,source:"https://www.youtube.com/embed/eA8s0CBFug4"},

      ],
      ovalnumber:1,
      vedioselect:"https://www.youtube.com/embed/wKPiBhxgCEA",
      }
  },
  created(){
      this.getnewslist()
    },
  methods:{
    sentfilter(a){
      this.filtername = a
      this.pagenumber = 1
      if(this.filtername === '企業活動'){
        this.filterchoice = '企業活動'
        this.active1 = ''
        this.active2 = ' active'
        this.active3 = ''
      }      
      else if(this.filtername === '金石盃賽'){
        this.filterchoice = '金石盃賽'
        this.active1 = ''
        this.active2 = ''
        this.active3 = ' active'
      }else{
        this.filterchoice = ''
        this.active1 = ' active'
        this.active2 = ''
        this.active3 = ''      
      }
      // console.log(this.filtername)
    },
    getnewslist(){
      this.newslist = [
          { id: 30, thefiltername: '企業活動', date: '2022.03.30', title: '新聞媒體', content: '圓夢大使贊助商 /工商時報',href:"https://admin.ctee.com.tw/industrynews/socialwelfare/619615.html"},
          { id: 29, thefiltername: '企業活動', date: '2022.03.25', title: '新聞媒體', content: '在林昀儒爆紅前就贊助他　36歲「狂人老闆」，要讓嘉義市走出桌球沙漠',href:"https://www.cw.com.tw/article/5120535"},
          { id: 28, thefiltername: '企業活動', date: '2022.03.19', title: '新聞媒體', content: '2022大同國小第53屆傑出校友',href:"https://www.chiayi.gov.tw/News_Content.aspx?n=455&s=637862"},
          { id: 27, thefiltername: '企業活動', date: '2022.03.04', title: '新聞媒體', content: '第21屆金峰獎《十大傑出企業》、《十大傑出領導人》',href:"https://www.cw.com.tw/article/5120535"},
          { id: 26, thefiltername: '企業活動', date: '2022.02.19', title: '新聞媒體', content: '嘉市首屆全國中小學桌球賽 鄭怡靜開球 /中央通訊社報導',href:"https://www.cna.com.tw/news/aloc/202202190111.aspx?fbclid=IwAR3GJbMNdhjanIZMzI8eJJsBKQe0MSXA3BHmkWQEORJtkv6NxUm437wMQGI"},
          { id: 25, thefiltername: '企業活動', date: '2022.01.20', title: '新聞媒體', content: '凝聚輔大人的桌球魂 經濟學系柯建利學長深耕回饋學校全方位/輔仁大學報導',href:"https://www.fju.edu.tw/focusDetail.jsp?focusID=1817&focusClassID=4"},
          { id: 24, thefiltername: '企業活動', date: '2022.01.12', title: '新聞媒體', content: '受邀中華民國不動產經營管理協會理事長林宏澔 節目【午餐房產學】採訪',href:"https://www.youtube.com/watch?v=zpQ69sKV_Vg"},
          { id: 23, thefiltername: '企業活動', date: '2021.11.26', title: '新聞媒體', content: '2021台灣百大最具影響力品牌品牌-建設居家類 /工商時報',href:"https://admin.ctee.com.tw/industrynews/socialwelfare/555552.html?fbclid=IwAR1-40njbLgQrMjq5lj_evb72FMP5ZVLIr_FapknA8TBJXy5-Kd9G8nFi2M"},
          { id: 22, thefiltername: '企業活動', date: '2021.11.12', title: '新聞媒體', content: '怪物職人企業形象獎',href:"https://www.youtube.com/watch?v=u0Ns1fPZdus"},
          { id: 21, thefiltername: '企業活動', date: '2021.09.03', title: '新聞媒體', content: '金石成大砌️‼️十年磨一案 嘉義最大場‼️',href:"https://www.facebook.com/kingstonecy1986/posts/4612047312163368"},
          { id: 20, thefiltername: '企業活動', date: '2021.07.26', title: '新聞媒體', content: '💥狂賀💥金石建設贊助選手林昀儒勇奪東奧銅牌🥉',href:"https://www.facebook.com/kingstonecy1986/videos/317499186770127/"},
          { id: 19, thefiltername: '企業活動', date: '2021.06.23', title: '新聞媒體', content: '【 房貸紓困 💰 金石幫您 】',href:"https://www.facebook.com/kingstonecy1986/posts/4399072870127481"},
          { id: 17, thefiltername: '金石盃賽', date: '2021.04.20', title: '金石盃賽', content: '金石桌球員工盃暖身賽圓滿落幕🎊',href:"https://www.facebook.com/kingstonecy1986/posts/4209401569094613"},
          { id: 16, thefiltername: '企業活動', date: '2021.04.17', title: '新聞媒體', content: '恭喜🎊🎊🎊金石建設柯建利總經理榮獲✨嘉中第11屆傑出校友✨',href:"https://www.facebook.com/kingstonecy1986/posts/4199109776790459"},
          { id: 14, thefiltername: '企業活動', date: '2021.03.07', title: '新聞媒體', content: '恭喜🎊台灣ㄧ哥林昀儒卡達桌賽獲獎',href:"https://www.facebook.com/kingstonecy1986/posts/4077842055583899"},
          { id: 13, thefiltername: '企業活動', date: '2021.02.24', title: '新聞媒體', content: '金石建設千人尾牙趴',href:"https://www.facebook.com/kingstonecy1986/videos/888501021897014/"},
          { id: 12, thefiltername: '企業活動', date: '2021.01.05', title: '新聞媒體', content: '金石鉑克萊 嘉義東區首選',href:"https://www.facebook.com/kingstonecy1986/posts/2978515155516600"},
          { id: 11, thefiltername: '企業活動', date: '2020.01.29', title: '新聞媒體', content: '台灣大未來 大年初一特別節目 金石建設',href:"https://www.facebook.com/kingstonecy1986/posts/2978515155516600"},
          { id: 1, thefiltername: '企業活動', date: '2020.01.09', title: '運動比賽', content: '金石乒乓球館成立 歡迎愛好桌球的朋友來運動',href:"https://www.facebook.com/%E9%87%91%E7%9F%B3%E4%B9%92%E4%B9%93%E7%90%83%E9%A4%A8-110772700450808/"},                   { id: 2, thefiltername: '企業活動', date: '2019.11.26', title: '新聞媒體', content: '✸✸狂賀✸✸恭喜金石建設獲國家建築金質獎🎉',href:"https://www.facebook.com/kingstonecy1986/posts/2833201443381306"},
          { id: 3, thefiltername: '企業活動', date: '2019.11.25', title: '新聞媒體', content: '金石建設贊助的桌球好手林昀儒獲得T2桌球新加坡站亞軍👍',href:"https://www.facebook.com/kingstonecy1986/posts/2830583966976387"},
          { id: 4, thefiltername: '企業活動', date: '2019.11.19', title: '員工旅遊', content: '金石建設瑞士12天員工旅遊',href:"https://www.facebook.com/kingstonecy1986/posts/2817231264978324"},
          { id: 6, thefiltername: '企業活動', date: '2019.10.24', title: '營業時間', content: '金石接待會館營業時間調整',href:"https://www.facebook.com/kingstonecy1986/posts/2759424147425703"},
          { id: 7, thefiltername: '金石盃賽', date: '2019.09.08', title: '金石盃賽', content: '第三屆金石建設輔大校友盃桌球賽',href:"https://www.facebook.com/kingstonecy1986/posts/2665549210146531"},
          { id: 8, thefiltername: '金石盃賽', date: '2019.09.04', title: '金石盃賽', content: '第二屆金石盃全國桌球錦標賽圓滿落幕',href:"https://www.facebook.com/media/set/?set=a.2657961567571962&type=3"},
          { id: 9, thefiltername: '企業活動', date: '2019.09.02', title: '新聞媒體', content: '2019傑出華商領袖論壇-馬英九總統與企業家面對面活動',href:"https://www.facebook.com/kingstonecy1986/posts/2653894891311963"},
          { id: 10, thefiltername: '企業活動', date: '2019.08.28', title: '新聞媒體', content: '金石建設董事長柯建利榮獲華人公益節-公益大使',href:"https://www.facebook.com/kingstonecy1986/posts/2644676765567109"},
        ]
    },
    pagesetting(i){
      this.pagenumber = i
      this.limiter = 0
      //console.log(this.pagenumber)
    },
    showthisvedio(vedio){
      this.ovalnumber = vedio.id
      this.vedioselect = vedio.source
    }
  },
  computed:{
    filternews(){
       return this.newslist.filter((data) => {
         if(data.thefiltername === this.filterchoice){
         return data.thefiltername.includes(this.filterchoice)
                }
         else if(this.filterchoice === '')
         return data
       })
    },
    pageoffsetnumber(){
      this.limit = 5
      this.setting = Math.ceil(this.filternews.length/ this.limit)
      // this.pageoffset = Math.ceil(this.showhow / this.limit)
      return this.setting
    },
  
  }

}
</script>
<style scoped>
.news{
  width: 100%;
  height: auto;
  margin:85px 0 0 0;
}

a{
  color: #7d7d7d;
  text-decoration: none;
}

#title h1{
  text-align: center;
  margin: 0% auto 12% auto;
  width: 100%;
  height: auto;
  padding: 1% 0;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.93px;
  color: #a89a80;
}

.container{
  width: 90%;
  height: auto;
  margin:  5% auto 5% auto;
  text-align:center;
  /* background-image: linear-gradient(to top, #c4c3c230 41%, #dadad93a 60%, #feffff79 100%); */
}

.btn{
  width: 88px;
  height: 37px;
  border: solid 1px #bbbbbb;
  background-color: #ffffff;
  font-size: 12.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.13px;
  color: #7d7d7d;
  cursor: pointer;
}
.btn.active{
  width: 88px;
  height: 37px;
  background-color: #c2b9a6;
  font-size: 12.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.13px;
  color: #ffffff;
  cursor: none;
}

.newslist{
  width:80%;
  height:auto;
  margin: 6% auto 0 auto;
}
@keyframes showupnews{
    0%{
      transform: translateY(12px);
    }
    100% {
        opacity: 1;
        }
    }

#newsdate, #newstitle{
  display: inline-block;
}
#newsdate{
  text-align: left;
  width: 20%;
  margin: 0 4% auto auto;
  height:auto;
  font-size: 10.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.95px;
  color: #b3b3b3;
}#newstitle{
  text-align: left;
  width: 70%;
  margin: 0 auto;
  height: auto;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #b5b5b5;
}#newscontent{
  text-align: left;
  width: 96%;
  height: auto;
  margin: 3% auto;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: 1.62px;
  color: #7c7a7a;
  opacity: 0;
  animation: showupnews 0.5s linear forwards;
  -webkit-animation: showupnews 0.5s linear forwards;
  animation-delay: 0.2s;
	-webkit-animation-delay: 0.2s;
}#newshr{
  width: 100%;
  height: 0px;
  margin: 0 auto;
  border: solid 0.5px #bbbbbb;
}
#pageoffset{
  text-align: center;
  height: auto;
  /* width: 20%; */
  height:auto;
  margin: auto auto ;
  /* border: solid #bbbbbb; */
}
#pagehrleft{
    display: inline-block;
    width: 18px;
    border: solid 0.3px #97979797;
    margin: 40px 3px 30px 0;
}
#pagehrright{
    display: inline-block;
    width: 18px;
    border: solid 0.3px #97979797;
    margin: 40px 0 30px 3px;
}
.pagep{
    margin: 40px 11px 30px 11px;
    vertical-align:bottom;
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.17px;
    text-align: justify;
    color: #8a8a8a;
}
.pagepactive{
  margin: 40px 11px 30px 11px;
  vertical-align:bottom;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.17px;
  text-align: justify;
  color: #d0ad76;
}
.pagep:hover{
  color: #d0ae76a8;
  cursor: pointer;
}
.newsvideo{
  width:95%;
  height:auto;
  margin: 10% auto 15% auto; 
  position: relative;
  text-align: center;
}

.video-container{
  margin: 20% auto 0% auto;
  width: 100%;
}
.yellowoval {
  display: inline-block;
  padding: 3px;
  margin: auto 2% 14% 2%;
  border-radius: 50%;
  border: solid 1px #dcc298;
  background-color: #dcc298;
}
.greyoval{
  display: inline-block;
  padding: 3px;
  margin: auto 2% 14% 2%; 
  border-radius: 50%;
  border: solid 1px #d8d8d8;
  background-color: #d8d8d8;
}

.greyoval:hover { cursor:pointer; }

button{
  outline: 0;
  box-shadow: none!important;
}
</style>